export const servicesList = [
  {
    slug: 'kasetli-tente',
    title: 'Kasetli Tente',
    shortDesc: 'Estetik görünümü ve pratik kullanımıyla balkon ve terasların vazgeçilmezi.',
    icon: 'ri-sun-line',
    image: '/images/services/kasetli-tente/main.webp',
  },
  {
    slug: 'koruklu-tente',
    title: 'Körüklü Tente',
    shortDesc: 'Katlanabilir yapısıyla geniş alanlara uygun, ekonomik ve dayanıklı çözüm.',
    icon: 'ri-layout-top-line',
    image: '/images/services/koruklu-tente/main.webp',
  },
  {
    slug: 'mafsalli-tente',
    title: 'Mafsallı Tente',
    shortDesc: 'Eklemli kol sistemiyle her açıya uyum sağlayan, esnek ve güçlü tente.',
    icon: 'ri-tools-line',
    image: '/images/services/mafsalli-tente/main.webp',
  },
  {
    slug: 't-model-tente',
    title: 'T Model Tente',
    shortDesc: 'T şeklindeki özel tasarımıyla köşe ve L alanlara mükemmel uyum.',
    icon: 'ri-layout-masonry-line',
    image: '/images/services/t-model-tente/main.webp',
  },
  {
    slug: 'win-tente',
    title: 'Win Tente',
    shortDesc: 'Rüzgara karşı üstün direnciyle öne çıkan, yüksek performanslı tente sistemi.',
    icon: 'ri-windy-line',
    image: '/images/services/win-tente/main.webp',
  },
  {
    slug: 'bioklimatik-pergola',
    title: 'Bioklimatik Pergola',
    shortDesc: 'Döner lamelli sistemiyle hava koşullarına göre ayarlanabilen akıllı pergola.',
    icon: 'ri-home-gear-line',
    image: '/images/services/bioklimatik-pergola/main.webp',
  },
  {
    slug: 'otomatik-pergola',
    title: 'Otomatik Pergola',
    shortDesc: 'Motorlu sistemiyle tek tuşla açılıp kapanan konforlu pergola çözümü.',
    icon: 'ri-remote-control-line',
    image: '/images/services/otomatik-pergola/main.webp',
  },
  {
    slug: 'rollingroof-pergola',
    title: 'Rollingroof Pergola',
    shortDesc: 'Rulo sistemiyle açılıp kapanan, yağmur ve güneşe karşı tam koruma.',
    icon: 'ri-contrast-drop-line',
    image: '/images/services/rollingroof-pergola/main.webp',
  },
  {
    slug: 'seffaf-branda',
    title: 'Şeffaf Branda',
    shortDesc: 'Görüş açısını kapatmadan rüzgar ve yağmurdan koruyan şeffaf perde sistemi.',
    icon: 'ri-eye-line',
    image: '/images/services/seffaf-branda/main.webp',
  },
  {
    slug: 'seffaf-stor-branda',
    title: 'Şeffaf Stor Branda',
    shortDesc: 'Stor mekanizmasıyla kolayca açılıp kapanan şeffaf branda sistemi.',
    icon: 'ri-stack-line',
    image: '/images/services/seffaf-stor-branda/main.webp',
  },
  {
    slug: 'zip-perde',
    title: 'Zip Perde',
    shortDesc: 'Fermuar sistemiyle rüzgara karşı sızdırmaz, dört mevsim kullanıma uygun perde.',
    icon: 'ri-shield-line',
    image: '/images/services/zip-perde/main.webp',
  },
];

export const serviceDetails: Record<string, {
  slug: string;
  title: string;
  h1: string;
  description: string;
  advantages: string[];
  usageAreas: string[];
  images: string[];
  ctaTitle: string;
  ctaSubtitle: string;
}> = {
  'kasetli-tente': {
    slug: 'kasetli-tente',
    title: 'Kasetli Tente',
    h1: 'Kasetli Tente İzmir | Balkon ve Teras İçin Şık Gölgeleme',
    description: 'Kasetli tente, kumaşın kullanılmadığında tamamen bir kasa içine çekildiği, estetik ve uzun ömürlü bir gölgeleme sistemidir. İzmir\'in güneşli iklimine mükemmel uyum sağlayan kasetli tenteler; balkon, teras ve bahçe alanlarında hem görsel hem de işlevsel bir çözüm sunar. Alüminyum kasası sayesinde kumaş her türlü hava koşulundan korunur, ömrü uzar. Motorlu veya manuel seçenekleriyle her bütçeye uygun modeller mevcuttur.',
    advantages: [
      'Kumaş kasaya tamamen çekildiğinden UV ve yağmurdan korunur',
      'Alüminyum kasa yapısı uzun ömür ve dayanıklılık sağlar',
      'Motorlu seçenekle tek tuşla açılıp kapanır',
      'Geniş kumaş ve renk seçeneği sunar',
      'Balkon, teras ve bahçeye kolayca monte edilir',
      'Rüzgar sensörü ile otomatik kapanma özelliği eklenebilir',
    ],
    usageAreas: ['Balkon', 'Teras', 'Bahçe', 'Kafe & Restoran', 'Otel Havuz Kenarı', 'Yazlık Ev'],
    images: [
      '/images/services/kasetli-tente/gallery-1.webp',
      '/images/services/kasetli-tente/gallery-2.webp',
      '/images/services/kasetli-tente/gallery-3.webp',
    ],
    ctaTitle: 'Kasetli Tente Fiyatı Öğrenmek İster misiniz?',
    ctaSubtitle: 'İzmir\'de ücretsiz ölçüm ve keşif hizmetimizden yararlanın. Uzman ekibimiz en uygun çözümü sizin için belirlesin.',
  },
  'koruklu-tente': {
    slug: 'koruklu-tente',
    title: 'Körüklü Tente',
    h1: 'Körüklü Tente İzmir | Geniş Alanlara Ekonomik Gölgeleme',
    description: 'Körüklü tente, katlanabilir kol mekanizmasıyla geniş açıklıkları kolayca kapatabilen, ekonomik ve pratik bir tente sistemidir. İzmir\'deki kafe, restoran ve işyeri teraslarında sıklıkla tercih edilen körüklü tenteler; dayanıklı kumaşı ve güçlü alüminyum kollarıyla uzun yıllar sorunsuz hizmet verir. Farklı genişlik ve uzunluk seçenekleriyle her alana özel çözüm üretilir.',
    advantages: [
      'Geniş açıklıkları tek parça kapatabilir',
      'Katlanabilir kol sistemi kompakt depolama sağlar',
      'Ticari ve konut projelerine uygun güçlü yapı',
      'Farklı kumaş ve renk seçenekleri mevcuttur',
      'Hızlı montaj ve kolay bakım',
      'Uygun fiyat politikasıyla bütçe dostu',
    ],
    usageAreas: ['Kafe & Restoran Terası', 'İşyeri Önü', 'Bahçe', 'Teras', 'Alışveriş Merkezi Dış Alanı', 'Okul Bahçesi'],
    images: [
      '/images/services/koruklu-tente/gallery-1.webp',
      '/images/services/koruklu-tente/gallery-2.webp',
      '/images/services/koruklu-tente/gallery-3.webp',
    ],
    ctaTitle: 'Körüklü Tente İçin Ücretsiz Keşif Talep Edin',
    ctaSubtitle: 'İzmir genelinde ücretsiz ölçüm yapıyor, en uygun fiyatı sunuyoruz.',
  },
  'mafsalli-tente': {
    slug: 'mafsalli-tente',
    title: 'Mafsallı Tente',
    h1: 'Mafsallı Tente İzmir | Esnek Kol Sistemiyle Tam Kontrol',
    description: 'Mafsallı tente, eklemli kol yapısı sayesinde farklı açılarda konumlandırılabilen, esnek ve güçlü bir gölgeleme sistemidir. Özellikle düzensiz cephe yapılarına ve köşeli alanlara mükemmel uyum sağlar. İzmir\'in değişken hava koşullarında bile güvenle kullanılabilen mafsallı tenteler; hem estetik hem de fonksiyonel bir çözüm arayanlar için idealdir.',
    advantages: [
      'Eklemli kol sistemi farklı açılarda konumlandırma imkânı sunar',
      'Düzensiz cephe ve köşeli alanlara uyum sağlar',
      'Güçlü alüminyum kol yapısı uzun ömür garantiler',
      'Motorlu ve manuel seçenekler mevcuttur',
      'Geniş kumaş renk yelpazesi',
      'Kolay bakım ve temizlik',
    ],
    usageAreas: ['Köşe Balkon', 'L Şekilli Teras', 'Bahçe Köşesi', 'Kafe Dış Alanı', 'Villa Terası', 'Yazlık'],
    images: [
      '/images/services/mafsalli-tente/gallery-1.webp',
      '/images/services/mafsalli-tente/gallery-2.webp',
      '/images/services/mafsalli-tente/gallery-3.webp',
    ],
    ctaTitle: 'Mafsallı Tente Fiyatı Almak İçin Arayın',
    ctaSubtitle: 'Uzman ekibimiz alanınızı ölçerek size en uygun mafsallı tente çözümünü sunar.',
  },
  't-model-tente': {
    slug: 't-model-tente',
    title: 'T Model Tente',
    h1: 'T Model Tente İzmir | Köşe Alanlara Özel Tasarım',
    description: 'T Model tente, özel T şeklindeki kol tasarımıyla köşe ve L biçimli alanları tek sistemle kapatmaya olanak tanır. Standart tentelerle çözülemeyen köşe sorunlarına pratik ve estetik bir yanıt sunan T model; İzmir\'deki villa, yazlık ve ticari mekânlarda giderek artan bir tercih haline gelmektedir. Sağlam yapısı ve geniş kaplama alanıyla öne çıkar.',
    advantages: [
      'Köşe ve L alanlara tek sistemle tam kaplama',
      'Standart tentelerle çözülemeyen sorunlara pratik çözüm',
      'Güçlü T kol yapısı geniş açıklıkları taşır',
      'Estetik görünüm, modern tasarım',
      'Motorlu seçenek mevcuttur',
      'Farklı kumaş ve renk alternatifleri',
    ],
    usageAreas: ['Köşe Teras', 'L Şekilli Balkon', 'Villa Bahçesi', 'Kafe Köşe Alanı', 'Otel Dış Mekânı', 'Yazlık Ev'],
    images: [
      '/images/services/t-model-tente/gallery-1.webp',
      '/images/services/t-model-tente/gallery-2.webp',
      '/images/services/t-model-tente/gallery-3.webp',
    ],
    ctaTitle: 'T Model Tente İçin Ücretsiz Keşif Talep Edin',
    ctaSubtitle: 'Köşe alanınıza özel çözüm için uzman ekibimizi arayın.',
  },
  'win-tente': {
    slug: 'win-tente',
    title: 'Win Tente',
    h1: 'Win Tente İzmir | Rüzgara Dayanıklı Yüksek Performanslı Tente',
    description: 'Win tente, özellikle rüzgarlı bölgeler için geliştirilmiş, güçlendirilmiş kol ve kumaş yapısıyla öne çıkan bir tente sistemidir. İzmir\'in Ege rüzgarlarına karşı üstün direnç gösteren Win tente; sahil, yüksek kat ve açık alanlarda güvenle kullanılabilir. Standart tentelere kıyasla çok daha yüksek rüzgar dayanımı sunar.',
    advantages: [
      'Yüksek rüzgar dayanımı, Ege iklimine uygun',
      'Güçlendirilmiş kol ve bağlantı noktaları',
      'Sahil ve yüksek kat uygulamalarına ideal',
      'Dayanıklı teknik kumaş seçenekleri',
      'Motorlu ve rüzgar sensörlü seçenek',
      'Uzun ömürlü, düşük bakım maliyeti',
    ],
    usageAreas: ['Sahil Kafe', 'Yüksek Kat Balkon', 'Açık Teras', 'Rüzgarlı Bölge', 'Marina', 'Otel Terası'],
    images: [
      '/images/services/win-tente/gallery-1.webp',
      '/images/services/win-tente/gallery-2.webp',
      '/images/services/win-tente/gallery-3.webp',
    ],
    ctaTitle: 'Win Tente Hakkında Bilgi Almak İçin Arayın',
    ctaSubtitle: 'Rüzgarlı bölgenize özel Win tente çözümü için ücretsiz keşif talep edin.',
  },
  'bioklimatik-pergola': {
    slug: 'bioklimatik-pergola',
    title: 'Bioklimatik Pergola',
    h1: 'Bioklimatik Pergola İzmir | Dört Mevsim Açık Hava Konforu',
    description: 'Bioklimatik pergola, döner alüminyum lamelleri sayesinde güneş, yağmur ve rüzgara karşı tam kontrol imkânı sunan akıllı bir dış mekân sistemidir. Lameller açıldığında doğal hava sirkülasyonu sağlanır; kapandığında ise yağmur geçirmez bir tavan oluşur. İzmir\'de dört mevsim açık hava yaşam alanı oluşturmak isteyenler için en gelişmiş çözümdür.',
    advantages: [
      'Döner lameller güneş açısına göre ayarlanabilir',
      'Yağmur geçirmez tavan özelliği',
      'Doğal hava sirkülasyonu sağlar',
      'LED aydınlatma ve ısıtıcı entegrasyonu mümkün',
      'Motorlu ve akıllı ev sistemleriyle uyumlu',
      'Dört mevsim kullanım imkânı',
    ],
    usageAreas: ['Villa Bahçesi', 'Restoran Terası', 'Otel Dış Mekânı', 'Yazlık', 'Kafe', 'Konut Terası'],
    images: [
      '/images/services/bioklimatik-pergola/gallery-1.webp',
      '/images/services/bioklimatik-pergola/gallery-2.webp',
      '/images/services/bioklimatik-pergola/gallery-3.webp',
    ],
    ctaTitle: 'Bioklimatik Pergola İçin Ücretsiz Keşif Talep Edin',
    ctaSubtitle: 'Dört mevsim açık hava konforunuz için uzman ekibimiz yanınızda.',
  },
  'otomatik-pergola': {
    slug: 'otomatik-pergola',
    title: 'Otomatik Pergola',
    h1: 'Otomatik Pergola İzmir | Motorlu Sistem, Maksimum Konfor',
    description: 'Otomatik pergola, motorlu mekanizması sayesinde uzaktan kumanda veya akıllı telefon uygulamasıyla kolayca kontrol edilebilen modern bir dış mekân çözümüdür. İzmir\'in güneşli günlerinde gölge, yağmurlu günlerde ise tam koruma sağlayan otomatik pergola; konfor ve teknolojiyi bir arada sunar. Hava sensörleriyle entegre edilerek tamamen otomatik çalışma modu da mümkündür.',
    advantages: [
      'Uzaktan kumanda veya akıllı telefon kontrolü',
      'Hava sensörü entegrasyonu ile tam otomasyon',
      'Güçlü motor sistemi uzun ömür garantiler',
      'Sessiz çalışma mekanizması',
      'LED aydınlatma ve ısıtıcı eklentisi mümkün',
      'Modern ve şık tasarım',
    ],
    usageAreas: ['Villa', 'Lüks Konut', 'Otel', 'Restoran', 'Yazlık', 'Bahçe'],
    images: [
      '/images/services/otomatik-pergola/gallery-1.webp',
      '/images/services/otomatik-pergola/gallery-2.webp',
      '/images/services/otomatik-pergola/gallery-3.webp',
    ],
    ctaTitle: 'Otomatik Pergola Fiyatı İçin Hemen Arayın',
    ctaSubtitle: 'Konforlu ve teknolojik dış mekân çözümü için ücretsiz keşif hizmetimizden yararlanın.',
  },
  'rollingroof-pergola': {
    slug: 'rollingroof-pergola',
    title: 'Rollingroof Pergola',
    h1: 'Rollingroof Pergola İzmir | Rulo Sistemli Tam Koruma',
    description: 'Rollingroof pergola, özel rulo mekanizmasıyla açılıp kapanan su geçirmez kumaş tavanıyla dış mekânları her hava koşulunda kullanılabilir hale getirir. Yağmur, güneş ve rüzgara karşı tam koruma sağlayan bu sistem; estetik görünümü ve pratik kullanımıyla İzmir\'deki kafe, restoran ve konut projelerinde giderek yaygınlaşmaktadır.',
    advantages: [
      'Su geçirmez kumaş tavan tam yağmur koruması sağlar',
      'Rulo mekanizması hızlı ve sessiz çalışır',
      'Motorlu seçenekle uzaktan kontrol',
      'Farklı kumaş renk ve desen seçenekleri',
      'Güçlü alüminyum taşıyıcı sistem',
      'Dört mevsim kullanıma uygun',
    ],
    usageAreas: ['Kafe Terası', 'Restoran Dış Alanı', 'Konut Bahçesi', 'Otel Havuz Kenarı', 'Yazlık', 'Ticari Alan'],
    images: [
      '/images/services/rollingroof-pergola/gallery-1.webp',
      '/images/services/rollingroof-pergola/gallery-2.webp',
      '/images/services/rollingroof-pergola/gallery-3.webp',
    ],
    ctaTitle: 'Rollingroof Pergola İçin Ücretsiz Keşif Talep Edin',
    ctaSubtitle: 'Her hava koşulunda dış mekânınızı kullanmak için uzman ekibimizi arayın.',
  },
  'seffaf-branda': {
    slug: 'seffaf-branda',
    title: 'Şeffaf Branda',
    h1: 'Şeffaf Branda İzmir | Görünümü Kapatmadan Tam Koruma',
    description: 'Şeffaf branda, yüksek kaliteli PVC malzemeden üretilen, görüş açısını kapatmadan rüzgar, yağmur ve soğuğa karşı etkili koruma sağlayan bir perde sistemidir. İzmir\'deki kafe ve restoran teraslarında kış aylarında da müşteri kapasitesini korumak için yaygın olarak kullanılır. Şeffaf yapısı sayesinde manzara ve doğal ışık kesilmez.',
    advantages: [
      'Yüksek şeffaflık, manzara ve ışık kesilmez',
      'Rüzgar ve yağmura karşı etkili koruma',
      'Kış aylarında teras kullanımını sürdürür',
      'Kolay açılıp kapanma mekanizması',
      'Farklı kalınlık seçenekleri mevcuttur',
      'Temizlenmesi ve bakımı kolaydır',
    ],
    usageAreas: ['Kafe & Restoran Terası', 'Balkon', 'Bahçe', 'İşyeri Önü', 'Otel Terası', 'Yazlık'],
    images: [
      '/images/services/seffaf-branda/gallery-1.webp',
      '/images/services/seffaf-branda/gallery-2.webp',
      '/images/services/seffaf-branda/gallery-3.webp',
    ],
    ctaTitle: 'Şeffaf Branda Fiyatı İçin Hemen Arayın',
    ctaSubtitle: 'Kış aylarında da terasınızı kullanmak için ücretsiz keşif talep edin.',
  },
  'seffaf-stor-branda': {
    slug: 'seffaf-stor-branda',
    title: 'Şeffaf Stor Branda',
    h1: 'Şeffaf Stor Branda İzmir | Pratik Rulo Mekanizmalı Şeffaf Perde',
    description: 'Şeffaf stor branda, rulo mekanizmasıyla kolayca açılıp kapanan, şeffaf PVC kumaştan üretilen pratik bir dış mekân perde sistemidir. Kullanılmadığında tamamen yukarı çekilerek görünmez hale gelir; ihtiyaç duyulduğunda ise saniyeler içinde indirilerek koruma sağlar. İzmir\'de hem konut hem de ticari projelerde tercih edilen estetik ve işlevsel bir çözümdür.',
    advantages: [
      'Rulo mekanizması hızlı ve pratik kullanım sağlar',
      'Kullanılmadığında tamamen gizlenir',
      'Şeffaf yapısıyla görüş açısını kapatmaz',
      'Rüzgar ve yağmura karşı etkili koruma',
      'Farklı genişlik seçenekleri mevcuttur',
      'Estetik ve modern görünüm',
    ],
    usageAreas: ['Balkon', 'Teras', 'Kafe Önü', 'İşyeri Cephesi', 'Bahçe', 'Yazlık'],
    images: [
      '/images/services/seffaf-stor-branda/gallery-1.webp',
      '/images/services/seffaf-stor-branda/gallery-2.webp',
      '/images/services/seffaf-stor-branda/gallery-3.webp',
    ],
    ctaTitle: 'Şeffaf Stor Branda İçin Ücretsiz Keşif Talep Edin',
    ctaSubtitle: 'Pratik ve estetik çözüm için uzman ekibimizi arayın.',
  },
  'zip-perde': {
    slug: 'zip-perde',
    title: 'Zip Perde',
    h1: 'Zip Perde İzmir | Dört Mevsim Sızdırmaz Perde Sistemi',
    description: 'Zip perde, fermuar (zip) sistemiyle kılavuz raylara kilitlenebilen, rüzgara karşı sızdırmaz bir dış mekân perde çözümüdür. Standart perdelerden farklı olarak rüzgarda savrulmaz; kenarları tamamen kapalı kalır. İzmir\'in Ege rüzgarlarına karşı üstün performans gösteren zip perde, dört mevsim kullanıma uygundur ve dış mekânları neredeyse kapalı alan konforuna taşır.',
    advantages: [
      'Fermuar sistemi rüzgarda savrulmayı önler',
      'Kenarlar tamamen kapalı, sızdırmaz yapı',
      'Dört mevsim kullanıma uygun',
      'Motorlu ve manuel seçenekler mevcuttur',
      'Şeffaf, yarı şeffaf ve opak kumaş alternatifleri',
      'Dış mekânı kapalı alan konforuna taşır',
    ],
    usageAreas: ['Teras', 'Balkon', 'Kafe & Restoran', 'Otel Dış Mekânı', 'Villa', 'Yazlık'],
    images: [
      '/images/services/zip-perde/gallery-1.webp',
      '/images/services/zip-perde/gallery-2.webp',
      '/images/services/zip-perde/gallery-3.webp',
    ],
    ctaTitle: 'Zip Perde Fiyatı Öğrenmek İçin Hemen Arayın',
    ctaSubtitle: 'Dört mevsim dış mekân konforu için ücretsiz keşif hizmetimizden yararlanın.',
  },
};
